import { render, staticRenderFns } from "./Logistic.vue?vue&type=template&id=538cc464"
import script from "./Logistic.vue?vue&type=script&lang=js"
export * from "./Logistic.vue?vue&type=script&lang=js"
import style0 from "./Logistic.vue?vue&type=style&index=0&id=538cc464&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports